import React from 'react';
import { Badge, Col, Form, Row } from 'react-bootstrap';
import {
  CARRIERS,
  GROUPS,
  RATE_SHOP_CARRIER_IDS
} from '../../config/rateShopConstants';
import HelpTip from '../HelpTip';
import BrandIcon from '../BrandIcon';
import { carrierIconFor } from '../../config/brandIcons';
const RatingOptions = ({ draft, update, disabled }) => (
  <>
    <p className="bg-light border rounded p-3 small">
      <strong>Rating methods</strong> decide how we ask ShipStation for prices →{' '}
      <strong>Carrier accounts</strong> decide which of your accounts are asked
      → <strong>Services allowed to win</strong> decide which results may be
      chosen.
    </p>
    <div className="mb-4">
      <h5>
        Rating methods{' '}
        <HelpTip label="Rating methods">
          These decide how we ask ShipStation for prices. An order can be
          checked in several ways so different package types can compete.
        </HelpTip>
      </h5>
      <p className="small text-muted">
        Choose the ways Rate Shop can check an order.
      </p>
      <Row className="g-3">
        {GROUPS.map(group => (
          <Col md={6} key={group.id}>
            <Form.Check
              id={`rate-shop-group-${group.id}`}
              type="switch"
              disabled={disabled}
              checked={Boolean(draft.groups[group.id])}
              onChange={e =>
                update({
                  groups: { ...draft.groups, [group.id]: e.target.checked }
                })
              }
              label={
                <span>
                  {group.label}
                  <HelpTip label={group.label}>{group.help}</HelpTip>
                </span>
              }
            />
            <p className="small text-muted mt-1">{group.help}</p>
          </Col>
        ))}
      </Row>
    </div>
    <div className="mb-4">
      <h5>
        Carrier accounts{' '}
        <HelpTip label="Carrier accounts">
          These decide which of your connected accounts are asked for prices. An
          account without a saved choice is enabled. Accounts you switch off
          are never asked for a price.
        </HelpTip>
      </h5>
      <p className="small text-muted">
        Choose which of your ShipStation carrier accounts Rate Shop may ask for
        prices.
      </p>
      <Row className="g-3">
        {[...CARRIERS]
          .sort(
            (a, b) =>
              Number(RATE_SHOP_CARRIER_IDS.includes(b.carrierId)) -
                Number(RATE_SHOP_CARRIER_IDS.includes(a.carrierId)) ||
              a.name.localeCompare(b.name)
          )
          .map(carrier => {
            const ready = RATE_SHOP_CARRIER_IDS.includes(carrier.carrierId);
            return (
              <Col md={6} key={carrier.carrierId}>
                <div className="border rounded p-2 h-100">
                  <Form.Check
                    id={`rate-shop-account-${carrier.carrierId}`}
                    disabled={disabled || !ready}
                    checked={
                      ready &&
                      draft.carrierAccounts?.[carrier.carrierId] !== false
                    }
                    onChange={e =>
                      update({
                        carrierAccounts: {
                          ...draft.carrierAccounts,
                          [carrier.carrierId]: e.target.checked
                        }
                      })
                    }
                    label={
                      <span>
                        <span className="d-inline-flex align-items-center gap-2">
                          <BrandIcon
                            src={carrierIconFor(carrier.carrierCode)}
                            alt={carrier.carrierCode}
                            size={24}
                          />
                          <span>{carrier.name}</span>
                        </span>{' '}
                        <Badge bg="light" text="dark">
                          {carrier.carrierCode}
                        </Badge>
                        <HelpTip label={carrier.name}>
                          {ready
                            ? 'Turn this account on to let its prices compete using the enabled rating methods.'
                            : 'This account is connected to ShipStation, but is not set up for rate shopping yet.'}
                        </HelpTip>
                        <span className="d-block small text-muted">
                          {carrier.carrierId}
                        </span>
                      </span>
                    }
                  />
                  {!ready && (
                    <p className="small text-muted mb-0 ms-4">
                      Not set up for rate shopping yet
                    </p>
                  )}
                </div>
              </Col>
            );
          })}
      </Row>
    </div>
  </>
);
export default RatingOptions;
